import { useEffect, useState } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { useGetSettingsQuery } from "@/app/settingsApi";
import { getMsalInstance } from "@/helpers";

const MOCK_AUTH = import.meta.env.VITE_PLAYWRIGHT_TESTING_MODE === "true";

export function useConfigureMsal() {
  const { data: settings } = useGetSettingsQuery();

  const [msalInstance, setMsalInstance] =
    useState<PublicClientApplication | null>(null);

  useEffect(() => {
    if (settings?.azureAdClientId) {
      const instance = getMsalInstance(settings.azureAdClientId);

      setMsalInstance(instance);
    }
  }, [settings?.azureAdClientId]);

  return {
    msalInstance: MOCK_AUTH
      ? new PublicClientApplication({ auth: { clientId: "mock-client-id" } })
      : msalInstance,
  };
}
